import React from 'react'

function MomEditPage() {
  return (
    <div>MomEditPage</div>
  )
}

export default MomEditPage